import { Component } from "@angular/core";
import { AuthService } from '../services/auth.service';
import { User } from '../model/user.model';
import { Router, ActivatedRoute } from '@angular/router';
import { PlayerService } from '../services/player.service';

@Component({
    selector: 'cabinet',
    templateUrl: './cabinet.component.html',
    styleUrls: ['./cabinet.component.scss'],
})
export class CabinetComponent {
    private readonly hebrewCollator = new Intl.Collator(["he", "en"], {
        usage: "sort",
        sensitivity: "base",
        ignorePunctuation: true,
        numeric: true,
    });

    constructor(
        private authService: AuthService,
        private playerService: PlayerService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        this.route.params.subscribe(p => {
            // if this is not multiuser or not authenticated then logout
            if (!this.user.children.length) {
                this.logout ();
            }
        });
    }

    get user(): User { return this.authService.user; }
    get currentUser(): User { return this.authService.currentUser; }
    get childrenSorted(): User[] {
        const children = (this.user && this.user.children) ? this.user.children : [];
        return [...children].sort((a: User, b: User) => {
            const aName = this.normalizeNameForSort((a.nick || a.name || '').toString());
            const bName = this.normalizeNameForSort((b.nick || b.name || '').toString());
            return this.hebrewCollator.compare(aName, bName);
        });
    }

    public logout(): void {
        this.playerService.stop();
        this.authService.logout();
        this.router.navigateByUrl("/auth/login");
    }

    public async setCurrentUser(newUser: User) {
        if (newUser.name !== this.currentUser.name && newUser.active) {
            this.playerService.stop();
            newUser.isChildUser = true;
            this.authService.setCurrentUser(newUser);
            await this.playerService.start();
            this.router.navigateByUrl("/tab1");
        }
    }

    public getUserClass(user: User): string {
        if (this.currentUser.name === user.name) {
            return "active";
        }
        else if (!user.active) {
            return "disabled";
        }
        else {
            return "";
        }
    }

    private normalizeNameForSort(value: string): string {
        const withoutMarks = value.normalize("NFKD").replace(/[\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7]/g, "");
        return withoutMarks.trim();
    }
}